module.exports = __webpack_public_path__ + "img/logo.48de1366.png";